import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import { adminApi } from '@/lib/api';
import { BarChart3, Users, Trophy, Swords, TrendingUp, Target } from 'lucide-react';

export default function AdminDashboardPage() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi.get('/admin/analytics')
      .then(r => setStats(r.data))
      // .catch(() => navigate('/admin/login'));
  }, [navigate]);

  if (!stats) {
    return <AdminLayout><div className="text-[#9CA3AF] animate-pulse">Lade Analytics...</div></AdminLayout>;
  }

  const cards = [
    { label: 'Quiz Starts', value: stats.totalStarts, icon: Target, color: '#3B82F6' },
    { label: 'Abgeschlossen', value: stats.totalCompletions, icon: BarChart3, color: '#10B981' },
    { label: 'Abschlussrate', value: `${stats.completionRate}%`, icon: TrendingUp, color: '#F59E0B' },
    { label: 'Bewerbungen', value: stats.totalLeads, icon: Users, color: '#8B5CF6' },
    { label: 'Konversionsrate', value: `${stats.conversionRate}%`, icon: Trophy, color: '#EF4444' },
    { label: 'Challenges', value: stats.challengesCreated, icon: Swords, color: '#60A5FA' },
  ];

  return (
    <AdminLayout>
      <div data-testid="admin-dashboard-page">
        <h1 className="font-outfit font-bold text-2xl text-white mb-6">Dashboard</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          {cards.map(card => (
            <div key={card.label} className="bg-[#121214] border border-white/5 rounded-xl p-5" data-testid={`stat-${card.label}`}>
              <div className="flex items-center justify-between mb-3">
                <span className="text-[#9CA3AF] text-sm">{card.label}</span>
                <card.icon className="w-5 h-5" style={{ color: card.color }} />
              </div>
              <p className="text-3xl font-outfit font-bold text-white">{card.value}</p>
            </div>
          ))}
        </div>

        <h2 className="font-outfit font-bold text-lg text-white mb-4">Level-Statistiken</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {Object.entries(stats.levelStats || {}).map(([level, data]) => (
            <div key={level} className="bg-[#121214] border border-white/5 rounded-xl p-5">
              <h3 className="font-outfit font-bold text-white capitalize mb-3">
                {level === 'anfaenger' ? 'Anfänger' : level === 'fortgeschritten' ? 'Fortgeschritten' : 'Experte'}
              </h3>
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-[#9CA3AF]">Starts</span>
                  <span className="text-white font-mono">{data.starts}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-[#9CA3AF]">Abgeschlossen</span>
                  <span className="text-white font-mono">{data.completions}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-[#9CA3AF]">Rate</span>
                  <span className="text-white font-mono">{data.starts > 0 ? Math.round(data.completions / data.starts * 100) : 0}%</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
